import {Application} from "../../lib/Application.js";
import PlannedTimeRepository from "../PlannedTimeRepository.js";
import {SettingsRepository} from "../../app/SettingsRepository.js";
import {CustomerRepository} from "../../crm/CustomerRepository.js";
import ClickUpPlannedTimeRepository from "../clickup/ClickUpPlannedTimeRepository.js";
import {ClickUpClient} from "../../lib/ClickUp/ClickUpClient.js";

/** @param {Application} app **/
export function initTimePlan(app) {

    app.bind(PlannedTimeRepository, () => {
        let settingsRepo = app.resolve(SettingsRepository);
        let settings = settingsRepo.get();
        let customerRepository = app.resolve(CustomerRepository);

        return new ClickUpPlannedTimeRepository(
            app.resolve(ClickUpClient),
            customerRepository,
            settings.defaultWorkSpaceId
        );

    });

}